import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
// Components
import { Intro } from './Components/Intro'
import { Clases } from './Components/Clases'
import { Acerca } from './Components/Acerca'
import { Contacto } from './Components/Contacto'

import './corriendoalmar.css'


export function CorriendoAlMar() {
  // scroll arriba
  useEffect(() => {
    window.scroll({
      top: 0
    })

  }, [])


  return (
    <div className='corriendoalmar-main'>
      <Helmet>
        <title>Tincho en el Bajo</title>
      </Helmet>
      <main>

        <div className="back1" id="bg1">
          <div className="filter"></div>
          <img src="/assets/img/corriendoalmar_500px.jpg" />
        </div>

          <Clases />

      </main>
    </div>
  )
}
